import { Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledSvgIconWrapper = styled.svg`
    width: ${Tokens.SIZES["2"]};
    height: ${Tokens.SIZES["2"]};
`;
